import React, {useEffect, useState} from 'react';
import styles from '../components/AboutBio.module.scss';
import BioList from './BioList';
import { Typography, Container, Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import axiosClient from '../data/axiosClient';
import LoadingComponent from '../components/LoadingComponent';
import BioDetail from '../components/BioDetail';

const About = () => {
  const [bioArray, setBioArray] = useState([]);
  const [aboutText, setAboutText] = useState('');
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  const [openModal, setOpenModal] = useState(false);
  const [selectedBio, setSelectedBio] = useState(null);

  useEffect(() => {
    // Function to perform the data fetching
    const fetchData = async () => {
      try {
        axiosClient.get('/biographies')
        .then(function (response) {
          setError(false);
          setBioArray(response.data.bios);
          setAboutText(response.data.about || '');
        })
        .catch(function (error) {
          setError(true);
          console.error('No applications listed in database');
        });
      } catch (err) {
        // Handle any errors during fetch or JSON parsing
        setError(err.message);
      } finally {
        // Set loading to false regardless of success or failure
        setLoading(false);
      }
    };

    // Call the async function
    fetchData(); 
  }, []);

  // 4. Render based on the state (loading, error, or data)
  if (loading) {
    return <LoadingComponent fullwidth={false} dismissable={true} state="loading" />
  }

  if (error) {
    <LoadingComponent fullwidth={false} dismissable={true} state="error"  />
  }

  const handleThumbnailClick = (bio) => {
    // TODO display modal with bio details
    setSelectedBio(bio);
    setOpenModal(true);
  };

  return (
    <Container maxWidth="lg" className={styles.aboutContainer}>
      <Box maxWidth="lg" className={styles.impose}>
        <div className={styles.aboutBox}>
          <Typography variant="h4" gutterBottom className={styles.aboutTitle}>
            About the ARM Tools Application
          </Typography>
          <div className={styles.aboutTextContainer}>
            <Typography variant="h5" gutterBottom className={styles.aboutText}>
              <div dangerouslySetInnerHTML={{ __html: aboutText}} />
            </Typography>
          </div>  
        </div>
        <div className={styles.bioListContainer}>
          <BioList Bios={bioArray} ThumbnailClick={handleThumbnailClick} />
        </div>
      </Box>
      <Modal 
        open={openModal} 
        onClose={() => setOpenModal(false)} 
        aria-labelledby="biography-detail" 
        aria-describedby="modal-biography-detail">
        <Box className={styles.modalContent}>
          {selectedBio && <div styles={{height: '100%'}}>
            <BioDetail Bio={selectedBio} OnClose={() => setOpenModal(false)} />
          </div>}
        </Box>
      </Modal>       
    </Container>
  )
}

export default About